exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cart-order-total {\n  font-weight:bold ;\n  font-size: 21px;\n}\n\n", ""]);

// exports
